const video = {
  "video.source.language": "en-auto"
}

export {
  video
}
